import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ImportExportCustomersComponent } from './import-export-customers/import-export-customers.component';
import { CustomerInfoModalComponent } from './customer-info-modal/customer-info-modal.component';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { NgChartsModule } from "ng2-charts";
import { ExportFilePopupComponent } from './export-file-popup/export-file-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExportComponentComponent } from './export-component/export-component.component';
import { SupportComponent } from '../pages/support/support.component';
import { SupportChoiceModalComponent } from './support-choice-modal/support-choice-modal.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    NgChartsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ProgressBarComponent,
    ImportExportCustomersComponent,
    CustomerInfoModalComponent,
    DoughnutChartComponent,
    BarChartComponent,
    ExportFilePopupComponent,
    ExportComponentComponent,
    SupportComponent,
    SupportChoiceModalComponent
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ProgressBarComponent,
    ImportExportCustomersComponent,
    CustomerInfoModalComponent,
    DoughnutChartComponent,
    BarChartComponent,
    ExportFilePopupComponent,
    ExportComponentComponent,
    SupportComponent,
    SupportChoiceModalComponent
  ],
  providers: [DecimalPipe]
})


export class ComponentsModule { }

